import { ButtonBase, Radio, Stack, Typography, useTheme } from "@mui/material";

interface Props {
  label: string;
  description?: string;
  isChecked: boolean;
  onChange: () => void;
}

const CreditCardDetails = ({ label, description, isChecked, onChange }: Props) => {
  const { palette } = useTheme();
  
  return (
    <ButtonBase         
      sx={{
        px: 3,
        width: "100%",
        justifyContent: "flex-start",
        "&:hover": {
          backgroundColor: palette.action.hover,
        },
      }}
      onClick={onChange}
    >
      <Stack direction="row" spacing={2} alignItems={"center"} justifyContent={"space-between"} flex={1}>
        <Typography color="text.primary">{label}</Typography>
        <>
          <Typography color="text.primary">
            {description}
          </Typography>
          <Radio size="small" checked={isChecked} onChange={onChange} />
        </>
      </Stack>
    </ButtonBase>
  );
};

export default CreditCardDetails;
